module.exports = __webpack_public_path__ + "static/media/ic-menu-sp-back.985eb1e9.svg";